//COURSES & GROUPS ACTIONS----------------------------------------------------------------------------------------------
(()=> {
    const searchParams = new URLSearchParams(window.location.search);

    let groupsArray = Array();
    const groupsView = (gid = 0) => {
        let cid = searchParams.get('cid'),
            currency = document.getElementById('groups').dataset.currency;
        gid = searchParams.get('gid');

        document.getElementById('groups-tab').innerHTML = '';
        document.getElementById('groups-tabContent').innerHTML = '';

        postData('/actions/dash/courses.php', {act: 1, cid: cid}).then((data) => {
            groupsArray = data;
            if (groupsArray.length > 0) {
                groupsArray.forEach((group, key) => {
                    let elemNav = document.createElement("button"),
                        elemTab = document.createElement("div"),
                        infoBlock = document.createElement("div"),
                        stuList = document.createElement('table'),
                        stuListBody = document.createElement('tbody'),
                        groupActions = document.createElement('div'),
                        gLocation = '';
                        //groupBtnAdd = document.createElement('button');

                    elemNav.id = `group-${group.id}`;
                    elemNav.classList.add('nav-link');
                    elemNav.dataset.bsToggle = 'pill';
                    elemNav.dataset.bsTarget = `#group-list-${group.id}`;
                    elemNav.type = 'button';
                    elemNav.role = 'tab';
                    elemNav.innerText = group.comment;

                    elemTab.id = `group-list-${group.id}`;
                    elemTab.classList.add('tab-pane', 'fade');
                    elemTab.role = 'tabpanel';

                    if (gid === null && key === 0) {
                        elemNav.classList.add('active');
                        elemTab.classList.add('show', 'active');
                    }

                    if (group.id === Number(gid)) {
                        elemNav.classList.add('active');
                        elemTab.classList.add('show', 'active');
                    }

                    document.getElementById('groups-tab').appendChild(elemNav);
                    document.getElementById('groups-tabContent').appendChild(elemTab);

                    infoBlock.innerHTML = `<h5>${group.comment}</h5>`;
                    if (group.start_time) infoBlock.innerHTML += `<p class="mb-lg-1"><strong>Start time:</strong> ${group.start_time}</p>`;
                    if (group.location) gLocation = ` <a href="${group.location}" class="link-brand-secondary text-decoration-underline" target="_blank">Show on map</a>`;
                    if (group.address) infoBlock.innerHTML += `<p class="mb-lg-1"><strong>Address:</strong> ${group.address}${gLocation}</p>`;
                    let weekDaysBlock = document.createElement("p");
                    weekDaysBlock.classList.add('text-capitalize');
                    weekDaysBlock.innerHTML = '<strong>Days: </strong>';
                    if (group.days) {
                        let weekDays = JSON.parse(group.days);
                        weekDays.forEach(day => {
                            weekDaysBlock.innerHTML += `<span class="px-3 py-1 border rounded-4 mx-1">${day} </span>`;
                        });
                    } else {
                        weekDaysBlock.innerHTML = '';
                    }
                    infoBlock.appendChild(weekDaysBlock);

                    elemTab.appendChild(infoBlock);

                    stuList.classList.add('table', 'group-table', 'mb-0');
                    stuList.innerHTML = `
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Date of added</th>
                            <th class="d-none d-md-table-cell">Balance</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                `;
                    elemTab.appendChild(stuList);
                    stuList.appendChild(stuListBody);

                    if (group['students'].length > 0) {
                        group['students'].forEach((student) => {
                            let stuListRow = document.createElement("tr"),
                                group_date = student.date ? new Date(student.date * 1000) : '';

                            group_date = group_date ? group_date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '&mdash;';
                            stuListRow.id = `stu-${student.id}`;
                            stuListRow.innerHTML = `
                                <td><a href="profile.html?sid=${student.id}">${student.name} ${student.surname}</a></td>
                                <td>${group_date}</td>
                                <td class="d-none d-md-table-cell ${student.balance > 0 ? 'text-success' : 'text-danger'}${student.balance === 0 ? 'text-body' : ''}">${currency === 'EUR' ? '&euro;' : currency} ${student.balance}</td>
                                <td class="text-center">
                                    <a href="#" class="btn btn-brand-secondary btn-sm d-none" title="Attendance"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20px" height="20px" fill="#fff"><path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"/></svg></a>
                                    <button class="btn btn-danger btn-sm del-stu-group" title="Remove" data-gid="${group.id}" data-sid="${student.id}"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="#fff" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"></path></svg></button>
                                </td>
                            `;
                            stuListBody.appendChild(stuListRow);
                        });
                    } else {
                        let stuListRow = document.createElement("tr");
                        stuListRow.innerHTML = `<td colspan="4">List is empty</td>`;
                        stuListBody.appendChild(stuListRow);
                    }

                    groupActions.classList.add('position-absolute', 'top-0', 'end-0');
                    groupActions.dataset.gid = group.id;
                    groupActions.innerHTML = `
                        <button class="btn btn-brand-secondary btn-sm" title="Add student" data-bs-toggle="modal" data-bs-target="#add-to-group" data-action="add" data-gid="${group.id}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="20px" height="20px" fill="#fff"><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                            <span class="d-none d-lg-inline">Add student</span>
                        </button> 
                        <button class="group-btn btn btn-brand-secondary btn-sm" title="Edit Group" data-action="edit" data-index="${key}" data-gid="${group.id}" data-del="${group.del}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20px" height="20px" fill="#fff"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"></path></svg>
                            <span class="d-none d-lg-inline">Edit Group</span>
                        </button> 
                        <button class="group-btn btn btn-brand-secondary btn-sm" title="Delete Group" data-action="del" data-gid="${group.id}" data-page="group">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20px" height="20px" fill="#fff"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path></svg>
                            <span class="d-none d-lg-inline">Delete Group</span>
                        </button>
                    `;
                    elemTab.prepend(groupActions);
                });
            } else {
                document.getElementById('groups').innerHTML = '<div class="text-brand-secondary text-center">No study groups</div>';
            }
        }).then(() => {
            const groupBtn = document.querySelectorAll('.group-btn');
            Array.from(groupBtn).forEach((elem) => {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    let action = e.currentTarget.dataset.action,
                        gIndex = e.currentTarget.dataset.index,
                        gid = e.currentTarget.dataset.gid;
                    groupAction(action, gIndex, gid);
                });
            });
        });
    }

    document.addEventListener('click', function(event) {
        if (event.target && event.target.matches('.del-stu-group')) {
            event.preventDefault();
            if (confirm('Delete student from course?')) {
                postData('/actions/dash/courses.php', {act: 10, gid: event.target.dataset.gid, sid: event.target.dataset.sid}).then((data) => {
                    if (data.success) {
                        document.getElementById(`stu-${event.target.dataset.sid}`).remove();
                    }
                }).catch(error => console.error(error));
            }
        }
    });

    const groupAction = (action, index, gid) => {
        let modal = document.getElementById('add-group'),
            groupModal = bootstrap.Modal.getOrCreateInstance(modal);

        if (action === 'add') {
            modal.querySelector('input[name=act]').value = 5;
            modal.querySelector('input[name=gid]').value = 0;
            groupModal.show();
        }
        if (action === 'edit') {
            modal.querySelector('.modal-title').innerText = 'Edit Group';
            modal.querySelector('input[name=act]').value = 6;
            modal.querySelector('input[name=gid]').value = gid;
            modal.querySelector('#comment').classList.add('focus');
            modal.querySelector('#comment').value = groupsArray[index]['comment'];
            modal.querySelector('#start_time').classList.add('focus');
            modal.querySelector('#start_time').value = groupsArray[index]['start_time'];
            modal.querySelector('#address').classList.add('focus');
            modal.querySelector('#address').value = groupsArray[index]['address'];
            modal.querySelector('#location').classList.add('focus');
            modal.querySelector('#location').value = groupsArray[index]['location'];

            if (groupsArray[index]['days']) {
                let groupDays = JSON.parse(groupsArray[index]['days']);
                groupDays.forEach((elem) => {
                    modal.querySelector('#' + elem).checked = true;
                });
            }

            groupModal.show();
        }
        if (action === 'del') {
            if (confirm(`Delete group?`)) {
                postData('/actions/dash/courses.php', {act: 7, gid: gid}).then((data) => {
                    groupsView();
                });
            }
        }
    }


    const pageView = document.getElementById('view');
    if (pageView) {
        groupsView();

        const btnAddGroup = document.getElementById('btn-add-group');
        btnAddGroup.addEventListener('click', (e) => {
            let form = document.querySelector('#add-group form'),
                formData = new FormData(form);
            const values = Object.fromEntries(formData.entries());

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
            } else {
                let loading = document.createElement('div');
                loading.classList.add('loading', 'd-flex', 'justify-content-center', 'align-items-center');
                loading.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>';
                form.parentNode.parentNode.appendChild(loading);
                postData('/actions/dash/courses.php', values).then((data) => {
                    groupsView(data[1]);
                    const myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('add-group'));
                    myModal.hide();
                });
            }
        });

        const createModalStuList = (gid, cid, param = '') => {
            let preloader = document.createElement('div');

            preloader.classList.add('stu-list-preloader', 'd-flex', 'align-items-center', 'justify-content-center', 'z-2', 'm-3');
            preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
            addStuModal.querySelector('.modal-content').appendChild(preloader);

            postData('/actions/dash/courses.php', {act: 8, gid: gid, cid: cid, param: param}).then((data) => {
                modalStuList(data[0]);
                document.querySelector('.stu-list-preloader').remove();
            });
        }

        const modalStuList = (data) => {
            const stuList = document.getElementById('modalStuList');
            stuList.innerHTML = '';
            let elem = document.createElement('ul');

            elem.classList.add('list-unstyled', 'mt-4');

            data.forEach((data) => {
                elem.innerHTML += `
                        <li class="pb-2">
                            <input id="stu-${data.id}" class="form-check-input p-2" type="checkbox" value="${data.id}">
                            <label for="stu-${data.id}">${data.name} ${data.surname}</label>
                        </li>
                    `;
            });

            stuList.appendChild(elem);
        }

        const addStuModal = document.getElementById('add-to-group')
        addStuModal.addEventListener('show.bs.modal', event => {
            const button = event.relatedTarget,
                  cid = searchParams.get('cid'),
                  gid = button.dataset.gid;
            createModalStuList(gid, cid);

            const resetBtn = document.getElementById('button-addon1');
            resetBtn.addEventListener('click', (e) => {
                createModalStuList(gid, cid);
            });

            const searchBtn = document.getElementById('button-addon2');
            searchBtn.addEventListener('click', (e) => {
                let search = document.getElementById('search').value;
                createModalStuList(gid, cid, search);
            });

            const addToGroupBtn = document.getElementById('addToGroupBtn');
            addToGroupBtn.addEventListener('click', (e) => {
                let elems = document.querySelectorAll('#modalStuList li input'),
                    stuList = Array();

                elems.forEach((elem) => {
                    if (elem.checked) stuList.push(elem.value);
                });

                stuList = JSON.stringify(stuList);
                postData('/actions/dash/courses.php', {act: 9, cid: cid, gid: gid, list: stuList}).then((data) => {
                    if (data.success) {
                        const _addStuModal = bootstrap.Modal.getOrCreateInstance(addStuModal);
                        _addStuModal.hide();
                        searchParams.set('gid', gid);
                        groupsView();
                    }
                });
            });
        });
    }
})();
//----------------------------------------------------------------------------------------------------------------------